import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-415037c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tiles"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "tiles__title" }, "Inhalte von ABALIR entdecken", -1))
const _hoisted_3 = { class: "tiles__grid" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "tile__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.tiles.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (tile, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: tile.link,
              class: "tile",
              target: "_blank",
              rel: "noopener"
            }, [
              _createElementVNode("img", {
                class: "tile__image",
                src: tile.image && tile.image.medium,
                alt: tile.title,
                loading: "lazy"
              }, null, 8, _hoisted_5),
              _createElementVNode("span", _hoisted_6, _toDisplayString(tile.title), 1)
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}